import { Container, Icon, Typography } from '@design-system';
import { Notification } from '@services';
import React from 'react';
import { MdOutlineAccessTimeFilled } from 'react-icons/md';
import './NotificationCard.scss';
import { useNotificationCard } from './useNotificationCard';

export type NotificationCardProps = {
    notification: Notification;
    onClick?: () => void;
};

export const NotificationCard: React.FC<NotificationCardProps> = ({ notification, onClick }) => {
    const { getIcon, getTypeLabel, formatAgo } = useNotificationCard(notification);

    return (
        <Container
            bordered="grey"
            className={`notification-card ${!notification.seen ? 'unread' : ''}`}
            padding="medium"
            onClick={() => onClick?.()}
        >
            <div className="notification-content">
                <div className="notification-header">
                    <Typography
                        intrinsic="h3"
                        color={!notification.seen ? 'marine' : 'grey'}
                        icon={getIcon()}
                        iconColor={!notification.seen ? 'green' : 'grey'}
                        iconSize={22}
                        defaultSpacing
                    >
                        {notification.title}
                    </Typography>
                </div>
                <div className="notification-text">
                    <Typography intrinsic="p" className="notification-description" color={!notification.seen ? 'marine' : 'grey'}>
                        {notification.content}
                    </Typography>
                </div>
            </div>
            <div className="notification-footer">
                <div className={`notification-time ${notification.seen ? 'read' : ''}`}>
                    <Typography intrinsic="p" variant="secondary" color="grey">
                        {getTypeLabel()}
                    </Typography>
                    <Icon icon={<MdOutlineAccessTimeFilled />} size={14} className="category-icon" color="grey" />
                    <Typography intrinsic="p" variant="secondary" color="grey">
                        {formatAgo(notification.date)}
                    </Typography>
                </div>
            </div>
        </Container>
    );
};
